<template>
  <div class="content tdi-page">

    <!-- ============================================================
         TOOLBAR CARD: Cấu hình tham số
         ============================================================ -->
    <div class="tdi-toolbar-card row-data">
      <div class="tdi-card-head">
        <div>
          <p class="tdi-card-title">
            <i class="el-icon-document" /> Sinh Phiếu Thu Nháp
          </p>
          <p class="tdi-card-subtitle">
            Cấu hình bộ lọc để tạo dữ liệu xem trước. Bao gồm thông tin bổ sung chi tiết cho phiếu thu nháp (điểm danh, ghi chú, đợt thu).
          </p>
        </div>
      </div>

      <el-form ref="configForm" :model="form" :rules="rules" label-position="top">
        <div class="tdi-form-grid">

          <!-- Cấu hình cơ bản: Phạm vi - Tháng - Đợt - Trạng thái -->
          <el-form-item label="Phạm vi" prop="targetType" class="tdi-form-item">
            <el-radio-group v-model="form.targetType" @change="handleTargetTypeChange">
              <el-radio-button label="CLASS">Theo lớp</el-radio-button>
              <el-radio-button label="GROUP">Theo nhóm</el-radio-button>
              <el-radio-button label="PACKAGE">Theo gói</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <!-- Tháng / Năm -->
          <el-form-item label="Tháng" prop="monthAndYear" class="tdi-form-item">
            <el-date-picker
              v-model="form.monthAndYear"
              type="month"
              placeholder="Chọn tháng"
              value-format="M-yyyy"
              format="MM-yyyy"
              :clearable="false"
              style="width: 135px"
              @change="handleMonthChange"
            />
          </el-form-item>

          <!-- Đợt thu -->
          <el-form-item label="Đợt thu" prop="collectionTurn" class="tdi-form-item">
            <el-select
              v-model="form.collectionTurn"
              placeholder="Chọn đợt"
              style="width: 110px"
              @change="handleTurnChange"
            >
              <el-option
                v-for="t in COLLECTION_TURNS"
                :key="t"
                :value="t"
                :label="`Đợt ${t}`"
              />
            </el-select>
          </el-form-item>

          <!-- Trạng thái học sinh -->
          <el-form-item label="Trạng thái học sinh" class="tdi-form-item">
            <el-select
              v-model="form.kidStatus"
              placeholder="Chọn trạng thái"
              style="width: 150px"
              @change="handleKidStatusChange"
            >
              <el-option
                v-for="item in kidStatusList"
                :key="item.key"
                :value="item.key"
                :label="item.label || item.value"
              />
            </el-select>
          </el-form-item>

          <!-- Chọn khối (chỉ hiện ở CLASS) -->
          <el-form-item v-if="isClassMode" label="Khối" class="tdi-form-item">
            <el-select
              v-model="form.idGrade"
              placeholder="Chọn khối"
              style="width: 140px"
              @change="handleGradeChange"
            >
              <el-option
                v-for="item in gradeOfSchoolList"
                :key="item.id"
                :value="item.id"
                :label="item.gradeName"
              />
            </el-select>
          </el-form-item>

          <!-- Chọn lớp (chỉ hiện ở CLASS) -->
          <el-form-item v-if="isClassMode" label="Lớp" prop="idClass" class="tdi-form-item">
            <el-select
              v-model="form.idClass"
              placeholder="Chọn lớp"
              style="width: 175px"
              @change="handleClassChange"
            >
              <el-option
                v-for="item in classList"
                :key="item.id"
                :value="item.id"
                :label="item.className"
              />
            </el-select>
          </el-form-item>

          <!-- Chọn nhóm (chỉ hiện ở GROUP) -->
          <el-form-item v-if="isGroupMode" label="Nhóm" prop="idGroup" class="tdi-form-item">
            <el-select
              v-model="form.idGroup"
              placeholder="Chọn nhóm"
              style="width: 220px"
              @change="handleGroupChange"
            >
              <el-option
                v-for="item in kidGroupList"
                :key="item.id"
                :value="item.id"
                :label="item.nameGroup"
              />
            </el-select>
          </el-form-item>

          <!-- Chọn gói (chỉ hiện ở PACKAGE) -->
          <el-form-item v-if="isPackageMode" label="Gói dịch vụ" prop="idPackage" class="tdi-form-item">
            <el-select
              v-model="form.idPackage"
              placeholder="Chọn gói"
              style="width: 220px"
              @change="handlePackageChange"
            >
              <el-option
                v-for="item in packageList"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
        </div>

        <div class="tdi-form-grid" style="margin-top: 12px;">
           <!-- Khoảng thời gian (thông tin bổ sung: thời gian gói) -->
           <el-form-item class="tdi-form-item tdi-form-item--wide">
             <template v-slot:label>
               Khoảng thời gian
               <el-tooltip content="Thời gian phiếu thu có hiệu lực" placement="top">
                 <i class="el-icon-question tdi-help-icon ml-1" style="cursor: pointer; color: #909399;" />
               </el-tooltip>
             </template>
             <el-date-picker
               v-model="form.dateRange"
               type="daterange"
               format="dd-MM-yyyy"
               range-separator="–"
               start-placeholder="Từ ngày"
               end-placeholder="Đến ngày"
               :picker-options="pickerOptions"
               style="width: 290px"
             />
           </el-form-item>

            <!-- Khoảng thời gian tính trước (override phiếu nháp) -->
            <el-form-item class="tdi-form-item tdi-form-item--wide">
              <template v-slot:label>
                Thời gian tính trước
                <el-tooltip content="Thời gian tính trước dùng để tính theo lịch học" placement="top">
                  <i class="el-icon-question tdi-help-icon ml-1" style="cursor: pointer; color: #909399;" />
                </el-tooltip>
              </template>
              <el-date-picker
                v-model="form.preCalcDateRange"
                type="daterange"
                format="dd-MM-yyyy"
                range-separator="–"
                start-placeholder="Từ ngày"
                end-placeholder="Đến ngày"
                :picker-options="pickerOptions"
                style="width: 290px"
                clearable
              />
            </el-form-item>

            <!-- Khoảng thời gian tính sau (override phiếu nháp) -->
            <el-form-item class="tdi-form-item tdi-form-item--wide">
              <template v-slot:label>
                Thời gian tính sau
                <el-tooltip content="Thời gian tính sau dùng để tính dựa trên dữ liệu điểm danh thực tế" placement="top">
                  <i class="el-icon-question tdi-help-icon ml-1" style="cursor: pointer; color: #909399;" />
                </el-tooltip>
              </template>
              <el-date-picker
                v-model="form.postCalcDateRange"
                type="daterange"
                format="dd-MM-yyyy"
                range-separator="–"
                start-placeholder="Từ ngày"
                end-placeholder="Đến ngày"
                :picker-options="pickerOptions"
                style="width: 290px"
                clearable
              />
            </el-form-item>

           <!-- Mô tả đợt thu (thông tin bổ sung: Nội dung ghi chú) -->
           <el-form-item label="Mô tả đợt thu" class="tdi-form-item tdi-form-item--wide">
            <el-input
              v-model="form.description"
              placeholder="Nhập mô tả đợt thu"
              style="width: 290px"
              clearable
            />
          </el-form-item>

        </div>

        <!-- ── Hàng 2: Khoản thu + Thông tin bổ sung ──────────────────
             (Tương ứng với 2 panel chính trong dialog AdditionalInfoDraftDialog:
             1. Thông tin điểm danh bổ sung
             2. Nội dung ghi chú = Thiếu / Thừa setting) -->
        <div class="tdi-option-row">

          <!-- Chọn khoản -->
          <div class="tdi-option-block">
            <span class="tdi-option-label">Khoản thu</span>
            <div class="tdi-option-content">
              <el-checkbox
                :indeterminate="isFeesIndeterminate"
                v-model="checkAllFees"
                @change="handleCheckAllFees"
              >
                Chọn tất cả
              </el-checkbox>
              <span class="tdi-fee-count">Đã chọn: {{ form.selectedFees.length }}</span>
              <span
                class="tdi-detail-link"
                @click="feeDialogVisible = true"
              >
                <i class="el-icon-view" /> Chi tiết
              </span>
            </div>
          </div>

          <!-- Dữ liệu điểm danh (đồng bộ với panel title trong dialog: "Thông tin điểm danh bổ sung") -->
          <div v-if="isClassMode" class="tdi-option-block tdi-option-block--attendance">
            <span class="tdi-option-label">
              Thông tin điểm danh bổ sung, dữ liệu điểm danh
              <el-tooltip
                :content="attendanceTooltipContent"
                placement="top"
              >
                <i class="el-icon-question tdi-help-icon" style="cursor: pointer; color: #909399; margin-left: 4px;" />
              </el-tooltip>
            </span>
            <div class="tdi-option-content">
              <el-radio v-model="form.monthBeforeOrAfter" :label="false">
                Tháng hiện tại ({{ currentAttendanceMonthText }})
              </el-radio>
              <el-radio v-model="form.monthBeforeOrAfter" :label="true">
                Tháng trước ({{ previousAttendanceMonthText }})
              </el-radio>
            </div>
            <div class="tdi-attendance-hint">
              <i class="el-icon-info" />
              <span v-if="form.monthBeforeOrAfter">
                Đang chọn: Lấy dữ liệu điểm danh của <strong>Tháng {{ previousAttendanceMonthText }}</strong> (tháng trước)
              </span>
              <span v-else>
                Đang chọn: Lấy dữ liệu điểm danh của <strong>Tháng {{ currentAttendanceMonthText }}</strong> (tháng hiện tại)
              </span>
            </div>
          </div>

          <!-- Thiếu / Thừa tháng trước -->
          <div class="tdi-option-block">
            <span class="tdi-option-label">Thiếu / Thừa</span>
            <div class="tdi-option-content">
              <el-radio
                v-model="form.allTransaction"
                :label="true"
                @change="handleBalanceRadio('allTransaction')"
              >Tất cả</el-radio>
              <el-radio
                v-model="form.forwardTransaction"
                :label="true"
                @change="handleBalanceRadio('forwardTransaction')"
              >Kết chuyển</el-radio>
              <el-radio
                v-model="form.noForwardTransaction"
                :label="true"
                @change="handleBalanceRadio('noForwardTransaction')"
              >Không chuyển</el-radio>
            </div>
          </div>

        </div>

        <!-- ── Danh sách học sinh để chọn ───────────────────── -->
        <div class="tdi-kid-list-block">
          <div class="tdi-kid-list-head">
            <div>
              <p class="tdi-kid-list-title">
                <i class="el-icon-user-solid" /> Danh sách học sinh nháp
              </p>
              <p class="tdi-kid-list-subtitle">
                Chọn học sinh để tạo phiếu thu nháp.
              </p>
            </div>
            <div class="tdi-kid-list-meta">
              <span>Đã chọn: <strong>{{ form.listIdKids.length }}</strong> / {{ kidDraftList.length }}</span>
              <el-button size="mini" icon="el-icon-refresh" @click="fetchKidsInDraft">Tải lại</el-button>
            </div>
          </div>

          <div class="tdi-kid-toolbar">
            <el-input
              v-model="kidKeyword"
              placeholder="Tìm theo mã hoặc tên học sinh..."
              prefix-icon="el-icon-search"
              clearable
              style="max-width: 320px"
            />
          </div>

          <el-table
            ref="kidDraftTable"
            :data="filteredKidDraftList"
            :empty-text="kidDraftLoading ? 'Đang tải danh sách học sinh...' : 'Chưa có học sinh phù hợp'"
            v-loading="kidDraftLoading"
            :max-height="$tableMaxHeight"
            :element-loading-text="$tableLoading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255,255,255,0)"
            border
            row-key="id"
            class="sk-table tdi-kid-table"
            @selection-change="handleKidSelectionChange"
          >
            <el-table-column type="selection" width="52" align="center" :reserve-selection="true" />
            <el-table-column type="index" label="STT" width="60" align="center" />
            <el-table-column prop="kidCode" label="Mã HS" width="120" align="center" />
            <el-table-column prop="name" label="Họ và tên" min-width="180" />
            <el-table-column label="Trạng thái" width="120" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="kidStatusTagType(row.status)" size="mini" effect="light">
                  {{ kidStatusLabel(row.status) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- ── Nút tạo phiếu ──────────────────────────────────── -->
        <div class="tdi-action-row">
          <el-button
            type="primary"
            icon="el-icon-document-checked"
            :loading="isLoading"
            @click="handleGenerate"
          >
            Xem trước phiếu thu nháp
          </el-button>
        </div>
      </el-form>
    </div>

    <!-- ============================================================
         TABLE CARD: Danh sách phiếu thu nháp
         ============================================================ -->
    <div v-if="hasResult" class="tdi-table-card row-data">
      <div class="tdi-card-head">
        <div>
          <p class="tdi-card-title">
            <i class="el-icon-tickets" /> Danh Sách Phiếu Thu Nháp
          </p>
          <div class="tdi-card-subtitle">
            <p>Tổng <strong>{{ invoiceList.length }}</strong> phiếu.</p>
            <ul class="tdi-info-list">
              <li>Mã phiếu thu sẽ được sinh khi khởi tạo phiếu chính thức.</li>
              <li>Mỗi 1 đợt thu của 1 học sinh trong 1 tháng thì chỉ có 1 phiếu thu duy nhất.</li>
              <li>Phiếu thu cũ (nếu có) sẽ bị ghi đè lên bởi phiếu thu mới, nếu phiếu thu cũ đã được thanh toán trực tuyến thì không thể khởi tạo phiếu thu mới cùng đợt trong tháng cho học sinh đó.</li>
            </ul>
          </div>
        </div>
        <el-tag type="warning" effect="dark" size="medium">
          <i class="el-icon-warning-outline" /> Dữ liệu xem trước – chưa lưu
        </el-tag>
      </div>

      <div class="tdi-table-wrapper">
        <el-table
          ref="invoiceDraftTable"
          :data="invoiceList"
          :empty-text="emptyText"
          v-loading="isLoading"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0)"
          :max-height="$tableMaxHeight"
          :summary-method="getSummaries"
          show-summary
          border
          row-key="idx"
          class="sk-table tdi-main-table"
          @selection-change="handleOfficialInvoiceSelectionChange"
        >
          <el-table-column type="selection" width="52" align="center" :reserve-selection="true" />
          <el-table-column type="index" label="STT" width="50" align="center" fixed="left" />

          <el-table-column label="Họ tên" prop="fullName" width="250" fixed="left" align="left">
            <template slot-scope="{ row }">
              <el-tooltip :content="`Mã HS: ${row.studentCode}`" placement="top">
                <span class="tdi-student-name-cell">{{ row.fullName }}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="Biệt danh" prop="nickName" width="130" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.nickName || "—" }}</span>
            </template>
          </el-table-column>

<!--          <el-table-column label="Mã phiếu thu" prop="invoiceCode" width="170" align="center">-->
<!--            <template slot-scope="{ row }">-->
<!--              <span v-if="row.invoiceCode">{{ row.invoiceCode }}</span>-->
<!--              <span v-else class="tdi-text-muted">—</span>-->
<!--            </template>-->
<!--          </el-table-column>-->

          <el-table-column label="Thông tin bổ sung" width="130" align="center">
            <template slot-scope="{ row }">
              <el-tooltip content="Xem thông tin bổ sung" placement="top">
                <el-button
                  type="text"
                  icon="el-icon-info"
                  class="tdi-additional-info-btn"
                  @click="handleOpenAdditionalInfo(row)"
                />
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="Trạng thái" align="center" width="140">
            <template slot-scope="{ row }">
              <el-tag :type="statusTagType(row.status)" size="mini" effect="light">
                {{ statusLabel(row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="Đợt" prop="turn" width="60" align="center" />
          <el-table-column label="Tháng-Năm" width="100" align="center">
            <template slot-scope="{ row }">
              {{ row.month }}/{{ row.year }}
            </template>
          </el-table-column>

          <el-table-column label="Thiếu/Thừa trước" prop="beforeMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span :class="row.beforeMoney < 0 ? 'tdi-money--negative' : 'tdi-money--positive'">
                {{ row.beforeMoney | formatCurrency }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="Phải thu tháng này" prop="sumMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span class="tdi-money tdi-money--bold">{{ row.sumMoney | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Đã thu" prop="collectedMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                class="tdi-fee-amount"
                @click="handleEditCollectedMoney(row)"
              >
                <span v-if="row.collectedMoney" class="tdi-money">{{ row.collectedMoney | formatCurrency }}</span>
                <span v-else class="tdi-money tdi-text-muted">-</span>
              </el-button>
            </template>
          </el-table-column>

          <el-table-column label="Tiền mặt" prop="cashMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span class="tdi-money">{{ row.cashMoney | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Chuyển khoản" prop="transferMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span class="tdi-money">{{ row.transferMoney | formatCurrency }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Thiếu/Thừa còn lại" prop="afterMoney" align="right" min-width="130" class-name="tdi-finance-column" label-class-name="tdi-finance-header">
            <template slot-scope="{ row }">
              <span :class="row.afterMoney < 0 ? 'tdi-money--negative' : 'tdi-money--positive'">
                {{ row.afterMoney | formatCurrency }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            v-for="(item, index) in feeColumns"
            :key="`${item.prop}-${index}`"
            align="right"
            width="140"
            :label="item.label"
            :prop="item.prop"
            class-name="tdi-fee-column"
            label-class-name="tdi-fee-header"
          >
            <template slot="header" slot-scope="scope">
              <el-tooltip :content="scope.column.label" placement="top">
                <span>{{ scope.column.label }}</span>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <el-button
                type="text"
                class="tdi-fee-amount"
                :disabled="!isFeeEditable(row, item.key)"
                @click="handleEditRevenueDetail(row, item)"
              >
                <span v-if="hasFeeAmount(row[item.prop])" class="tdi-money tdi-money--fee">
                  {{ row[item.prop] | formatCurrency }}
                </span>
                <span v-else class="tdi-money tdi-money--fee">-</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="tdi-table-action-row">
        <div class="tdi-table-action-summary">
          <span>
            Đã chọn phát hành chính thức:
            <strong>{{ selectedDraftInvoiceRows.length }}</strong>
            / {{ invoiceList.length }} phiếu
          </span>
          <span v-if="selectedDraftInvoiceRows.length === 0" class="tdi-table-action-hint">
            Chọn ít nhất một phiếu nháp để khởi tạo phiếu thu chính thức.
          </span>
        </div>

        <el-button
          type="success"
          icon="el-icon-collection"
          :loading="officialInvoiceLoading"
          :disabled="officialInvoiceLoading || selectedDraftInvoiceRows.length === 0"
          @click="handleCreateOfficialInvoices"
        >
          Khởi tạo phiếu thu chính thức
        </el-button>
      </div>
    </div>

    <!-- Dialog chỉnh sửa chi tiết khoản thu -->
    <edit-revenue-detail-dialog
      ref="editDetailDialog"
      @saved="handleRevenueDetailSaved"
    />
    <edit-collected-money-draft-dialog
      ref="editCollectedMoneyDialog"
      @saved="handleCollectedMoneySaved"
    />
    <additional-info-draft-dialog
      :visible.sync="additionalInfoDialogVisible"
      :loading="additionalInfoLoading"
      :info="additionalInfoData || {}"
      :month="additionalInfoContext.month"
      :year="additionalInfoContext.year"
      :turn="additionalInfoContext.turn"
      :student-name="additionalInfoContext.studentName"
      @saved="handleAdditionalInfoSaved"
      @close="additionalInfoData = null"
    />

    <!-- ============================================================
         Dialog: Chọn khoản thu
         ============================================================ -->
    <el-dialog
      title="Danh sách khoản thu"
      :visible.sync="feeDialogVisible"
      width="580px"
      top="6vh"
      :before-close="() => { feeDialogVisible = false; }"
      @open="handleFeeDialogOpen"
    >
      <!-- Thanh tìm kiếm + đếm -->
      <div class="tdi-fd-toolbar">
        <el-input
          v-model="feeKeyword"
          placeholder="Tìm theo mã hoặc tên khoản..."
          prefix-icon="el-icon-search"
          clearable
          style="max-width: 320px"
        />
        <span class="tdi-fd-count">
          Đã chọn:
          <strong class="tdi-fd-count-val">{{ form.selectedFees.length }}</strong>
          / {{ feeOptions.length }}
        </span>
      </div>

      <!-- Danh sách checkbox dạng list -->
      <div class="tdi-fd-list">
        <!-- Trạng thái rỗng -->
        <div v-if="feeOptions.length === 0" class="tdi-fd-empty">
          <i class="el-icon-document-remove tdi-fd-empty-icon" />
          <p>Chưa có khoản thu nào. Vui lòng chọn lớp / nhóm và tháng trước.</p>
        </div>

        <template v-else>
          <div v-if="filteredFeeOptions.length === 0" class="tdi-fd-empty">
            <i class="el-icon-search tdi-fd-empty-icon" />
            <p>Không tìm thấy khoản thu phù hợp.</p>
          </div>

          <div
            v-for="item in filteredFeeOptions"
            :key="item.id"
            class="tdi-fd-item"
            :class="{ 'tdi-fd-item--checked': form.selectedFees.indexOf(item.id) !== -1 }"
            @click="toggleFeeItem(item.id)"
          >
            <el-checkbox
              :value="form.selectedFees.indexOf(item.id) !== -1"
              class="tdi-fd-checkbox"
              @change="toggleFeeItem(item.id)"
              @click.native.stop
            />
            <el-tooltip
              v-if="item.code"
              :content="`Mã khoản: ${item.code}`"
              placement="top"
            >
              <span class="tdi-fd-label">{{ item.name }}</span>
            </el-tooltip>
            <span v-else class="tdi-fd-label">{{ item.name }}</span>
          </div>
        </template>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="feeDialogVisible = false">Xác nhận</el-button>
        <el-button @click="feeDialogVisible = false">Đóng</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import tuitionDraftInvoiceService from "@/services/tutition_v3/TuitionDraftInvoiceService";
import RevenueScopeService from "@/services/tutition_v3/RevenueScopeService";
import GroupExcelService from "@/services/Finance_Kids_V2/GroupExcelService";
import PackageManagementService from "@/services/tutition_v3/PackageManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import { kidStatusList } from "@/constant/listCommon";
import EditRevenueDetailDialog from "@/components/tutition_v3/dialog/EditRevenueDetailDialog.vue";
import EditCollectedMoneyDraftDialog from "@/components/tutition_v3/dialog/EditCollectedMoneyDraftDialog.vue";
import AdditionalInfoDraftDialog from "@/components/tutition_v3/dialog/AdditionalInfoDraftDialog.vue";

const COLLECTION_TURNS = Array.from({ length: 20 }, (_, i) => i + 1);

const STATUS_LABEL = {
  UNBILLED: "Chưa có phiếu thu",
  UNPAID: "Chưa đóng 100%",
  PARTIALLY_PAID: "Chưa đóng đủ",
  FULLY_PAID: "Đóng đủ 100%",
  OVERPAID: "Đóng thừa",
  FULLY_PAID_WITH_SURPLUS: "Đóng đủ thừa",
  PAID_WITH_DEFICIT: "Đóng đủ thiếu",
};

export default {
  name: "TuitionDraftInvoice",
  components: {
    AdditionalInfoDraftDialog,
    EditCollectedMoneyDraftDialog,
    EditRevenueDetailDialog,
  },

  data() {
    return {
      COLLECTION_TURNS,
      isLoading:        false,
      officialInvoiceLoading: false,
      hasResult:        false,
      emptyText:        "",
      invoiceList:      [],
      selectedDraftInvoiceRows: [],
      feeColumns:       [],
      feeOptions:       [],
      feeDialogVisible: false,
      feeKeyword:       "",
      checkAllFees:     false,
      isFeesIndeterminate: false,
      kidGroupList:     [],
      packageList:      [],
      kidStatusList,
      kidDraftList:     [],
      kidDraftLoading:  false,
      kidKeyword:       "",
      additionalInfoDialogVisible: false,
      additionalInfoLoading: false,
      additionalInfoData: null,
      additionalInfoDraftMap: {},
      additionalInfoContext: {
        month: null,
        year: null,
        turn: null,
        idStudent: null,
        invoiceId: null,
        invoiceIdx: null,
        targetType: "CLASS",
        studentName: "",
      },

      pickerOptions: {
        shortcuts: [
          {
            text: "Tháng này",
            onClick(picker) {
              const start = moment().startOf("month").toDate();
              const end   = moment().endOf("month").toDate();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Tháng trước",
            onClick(picker) {
              const start = moment().subtract(1, "month").startOf("month").toDate();
              const end   = moment().subtract(1, "month").endOf("month").toDate();
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      form: {
        targetType:          "CLASS",
        monthAndYear:        moment().format("M-yyyy"),
        month:               moment().month() + 1,
        year:                moment().year(),
        idGrade:             "",
        idClass:             "",
        idGroup:             "",
        idPackage:           "",
        kidStatus:           "STUDYING",
        listIdKids:          [],
        collectionTurn:      1,
        description:     "",
        dateRange:           [
          moment().startOf("month").toDate(),
          moment().endOf("month").toDate()
        ],
        selectedFees:        [],
        monthBeforeOrAfter:  false,
        allTransaction:      true,
        forwardTransaction:  false,
        noForwardTransaction: false,
        preCalcDateRange:    [
          moment().startOf("month").toDate(),
          moment().endOf("month").toDate()
        ],
        postCalcDateRange:   [
          moment().subtract(1, "month").startOf("month").toDate(),
          moment().subtract(1, "month").endOf("month").toDate()
        ],
      },

      rules: {
        targetType:     [{ required: true, message: "Vui lòng chọn phạm vi", trigger: "change" }],
        monthAndYear:   [{ required: true, message: "Vui lòng chọn tháng",   trigger: "change" }],
        collectionTurn: [{ required: true, message: "Vui lòng chọn đợt thu", trigger: "change" }],
        idClass: [
          {
            validator: (rule, val, cb) => {
              if (this.isClassMode && !val) return cb(new Error("Vui lòng chọn lớp"));
              cb();
            },
            trigger: "change",
          },
        ],
        idGroup: [
          {
            validator: (rule, val, cb) => {
              if (this.isGroupMode && !val) return cb(new Error("Vui lòng chọn nhóm"));
              cb();
            },
            trigger: "change",
          },
        ],
        idPackage: [
          {
            validator: (rule, val, cb) => {
              if (this.isPackageMode && !val) return cb(new Error("Vui lòng chọn gói dịch vụ"));
              cb();
            },
            trigger: "change",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState("gradeModule", ["gradeOfSchoolList"]),
    ...mapState("classStore",  ["classListCommon"]),

    classList() {
      return this.classListCommon.filter(
        (x) => x.idGrade === this.form.idGrade
      );
    },

    isClassMode() {
      return this.form.targetType === "CLASS";
    },

    isGroupMode() {
      return this.form.targetType === "GROUP";
    },
    isPackageMode() {
      return this.form.targetType === "PACKAGE";
    },

    filteredFeeOptions() {
      const kw = (this.feeKeyword || "").toLowerCase().trim();
      if (!kw) return this.feeOptions;
      return this.feeOptions.filter(
        (item) =>
          (item.name || "").toLowerCase().includes(kw) ||
          (item.code || "").toLowerCase().includes(kw)
      );
    },

    filteredKidDraftList() {
      const kw = (this.kidKeyword || "").toLowerCase().trim();
      if (!kw) return this.kidDraftList;
      return this.kidDraftList.filter(
        (item) =>
          (item.name || "").toLowerCase().includes(kw) ||
          (item.kidCode || "").toLowerCase().includes(kw)
      );
    },

    currentAttendanceMonthText() {
      const month = this.form.month || (this.form.monthAndYear ? Number(this.form.monthAndYear.split("-")[0]) : (moment().month() + 1));
      const year  = this.form.year  || (this.form.monthAndYear ? Number(this.form.monthAndYear.split("-")[1]) : moment().year());
      return `${month}/${year}`;
    },

    previousAttendanceMonthText() {
      const month = this.form.month || (this.form.monthAndYear ? Number(this.form.monthAndYear.split("-")[0]) : (moment().month() + 1));
      const year  = this.form.year  || (this.form.monthAndYear ? Number(this.form.monthAndYear.split("-")[1]) : moment().year());
      const prevDate = moment(`${year}-${month}`, "YYYY-M").subtract(1, "month");
      return `${prevDate.month() + 1}/${prevDate.year()}`;
    },

    attendanceMonthExplanation() {
      if (this.form.monthBeforeOrAfter) {
        return `Áp dụng dữ liệu điểm danh của Tháng ${this.previousAttendanceMonthText} (tháng trước tháng thu)`;
      }
      return `Áp dụng dữ liệu điểm danh của Tháng ${this.currentAttendanceMonthText} (tháng thu hiện tại)`;
    },

    attendanceTooltipContent() {
      return `Dữ liệu điểm danh thực tế được tính theo: Tháng hiện tại (${this.currentAttendanceMonthText}) hoặc Tháng trước (${this.previousAttendanceMonthText})`;
    },
  },

  watch: {
    gradeOfSchoolList: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0 && !this.form.idGrade) {
          this.form.idGrade = val[0].id;
        }
      },
    },
    classList: {
      handler(val) {
        if (val && val.length > 0) {
          this.form.idClass = val[0].id;
          this.fetchFeeOptions();
          this.fetchKidsInDraft();
        }
      },
    },
  },

  created() {
    this.$store.dispatch("gradeModule/fetchDataGradeOfSchoolList");
    this.$store.dispatch("classStore/fetchDataClassListCommon");
    this.fetchGroups();
    this.fetchPackages();
  },

  methods: {
    /* ─── Helpers ────────────────────────────────────── */
    statusLabel(status) {
      return STATUS_LABEL[status] || status || "—";
    },

    statusTagType(status) {
      const map = {
        UNBILLED: "info",
        UNPAID: "danger",
        PARTIALLY_PAID: "warning",
        FULLY_PAID: "success",
        OVERPAID: "success",
        FULLY_PAID_WITH_SURPLUS: "success",
        PAID_WITH_DEFICIT: "warning",
      };
      return map[status] || "info";
    },

    resetDraftInvoicePreview() {
      this.hasResult = false;
      this.emptyText = "";
      this.invoiceList = [];
      this.feeColumns = [];
      this.selectedDraftInvoiceRows = [];
      this.syncOfficialInvoiceSelection();
    },

    syncOfficialInvoiceSelection() {
      this.$nextTick(() => {
        const table = this.$refs.invoiceDraftTable;
        if (!table || !table.toggleRowSelection) return;

        table.clearSelection();
        const selectedIdxSet = new Set(
          (Array.isArray(this.selectedDraftInvoiceRows) ? this.selectedDraftInvoiceRows : [])
            .map((row) => row && (row.idx || row.id))
            .filter((key) => key !== undefined && key !== null && key !== "")
            .map((key) => String(key))
        );

        (Array.isArray(this.invoiceList) ? this.invoiceList : []).forEach((row) => {
          const rowKey = row.idx || row.id;
          if (rowKey && selectedIdxSet.has(String(rowKey))) {
            table.toggleRowSelection(row, true);
          }
        });
      });
    },

    handleOfficialInvoiceSelectionChange(rows) {
      this.selectedDraftInvoiceRows = Array.isArray(rows) ? rows : [];
    },

    normalizeOfficialDraftInvoices(rows) {
      return (Array.isArray(rows) ? rows : []).map((row) => {
        const draftInvoice = { ...row };
        Object.keys(draftInvoice).forEach((key) => {
          if (/^moneyKt\d+$/.test(key)) {
            delete draftInvoice[key];
          }
        });
        return draftInvoice;
      });
    },

    buildOfficialInvoicePayload(selectedRows) {
      const startDate = this.form.dateRange && this.form.dateRange[0]
        ? moment(this.form.dateRange[0]).format("YYYY-MM-DD")
        : null;
      const endDate = this.form.dateRange && this.form.dateRange[1]
        ? moment(this.form.dateRange[1]).format("YYYY-MM-DD")
        : null;

      const preCalcStartDate = this.form.preCalcDateRange && this.form.preCalcDateRange[0]
        ? moment(this.form.preCalcDateRange[0]).format("YYYY-MM-DD")
        : null;
      const preCalcEndDate = this.form.preCalcDateRange && this.form.preCalcDateRange[1]
        ? moment(this.form.preCalcDateRange[1]).format("YYYY-MM-DD")
        : null;

      const postCalcStartDate = this.form.postCalcDateRange && this.form.postCalcDateRange[0]
        ? moment(this.form.postCalcDateRange[0]).format("YYYY-MM-DD")
        : null;
      const postCalcEndDate = this.form.postCalcDateRange && this.form.postCalcDateRange[1]
        ? moment(this.form.postCalcDateRange[1]).format("YYYY-MM-DD")
        : null;

      const latestSelectedRows = (Array.isArray(selectedRows) ? selectedRows : []).map((selectedRow) => {
        const rowKey = selectedRow.idx || selectedRow.id;
        const matchedRow = this.invoiceList.find(
          (row) => (row.idx || row.id) === rowKey
        );
        return matchedRow || selectedRow;
      });

      return {
        targetType: this.form.targetType,
        month: this.form.month,
        year: this.form.year,
        idClass: this.isClassMode ? this.form.idClass : null,
        idGroup: this.isGroupMode ? this.form.idGroup : null,
        idPackage: this.isPackageMode ? this.form.idPackage : null,
        startDate,
        endDate,
        collectionTurn: this.form.collectionTurn,
        description: this.form.description || null,
        draftInvoices: this.normalizeOfficialDraftInvoices(latestSelectedRows),
        preCalcStartDate,
        preCalcEndDate,
        postCalcStartDate,
        postCalcEndDate,
      };
    },

    getFailedOfficialInvoiceIds(failedKids) {
      return new Set(
        (Array.isArray(failedKids) ? failedKids : [])
          .map((item) => Number(item?.id))
          .filter((id) => !Number.isNaN(id))
      );
    },

    getOfficialPublishResultMessage(successCount, failCount) {
      if (failCount > 0 && successCount > 0) {
        return `Phát hành thành công ${successCount} phiếu, không phát hành ${failCount} phiếu.`;
      }

      if (failCount > 0) {
        return `Không phát hành được phiếu nào. Số lượng phiếu không hợp lệ: ${failCount} phiếu.`;
      }

      return `Đã phát hành thành công ${successCount} phiếu thu.`;
    },

    handleOfficialPublishResponse(responseData) {
      const successCount = Number(responseData?.successCount || 0);
      const failCount = Number(responseData?.failCount || 0);
      const failedKids = Array.isArray(responseData?.failedKids) ? responseData.failedKids : [];

      if (successCount > 0 && failCount === 0) {
        NotifyMessage.leftCornerNotificationSuccess(this.getOfficialPublishResultMessage(successCount, failCount));
      } else if (successCount > 0) {
        NotifyMessage.leftCornerNotificationWarning(this.getOfficialPublishResultMessage(successCount, failCount));
      } else {
        NotifyMessage.leftCornerNotificationError(this.getOfficialPublishResultMessage(successCount, failCount));
      }

      if (successCount > 0) {
        this.resetDraftInvoicePreview();
      } else {
        const failedIds = this.getFailedOfficialInvoiceIds(failedKids);
        // Cũng hỗ trợ match bằng idx (UUID) cho trường hợp BE trả failedKids có idx
        const failedIdxSet = new Set(
          (Array.isArray(failedKids) ? failedKids : [])
            .map((item) => item?.idx)
            .filter(Boolean)
        );
        if (failCount === 0) {
          this.selectedDraftInvoiceRows = [];
        } else if (failedIds.size > 0 || failedIdxSet.size > 0) {
          this.selectedDraftInvoiceRows = this.invoiceList.filter((row) => {
            if (row.idx && failedIdxSet.has(row.idx)) return true;
            return failedIds.has(Number(this.resolveStudentId(row)));
          });
        }
        this.syncOfficialInvoiceSelection();
      }
    },

    kidStatusLabel(status) {
      const item = this.kidStatusList.find((x) => x.key === status);
      return (item && (item.label || item.value)) || status || "—";
    },

    kidStatusTagType(status) {
      const map = {
        STUDYING: "success",
        STUDY_WAIT: "warning",
        RESERVE: "info",
        LEAVE_SCHOOL: "danger",
      };
      return map[status] || "info";
    },

    /* ─── Fee dialog ─────────────────────────────────── */
    handleFeeDialogOpen() {
      this.feeKeyword = "";
    },

    handleKidStatusChange() {
      this.fetchKidsInDraft();
    },

    normalizeKidDraftList(list) {
      return (Array.isArray(list) ? list : [])
        .map((item) => {
          const rawId = item.id;
          const name = item.name || item.fullName || "";
          const kidCode = item.kidCode || item.code || "";
          if (rawId === undefined || rawId === null || rawId === "") return null;
          return {
            ...item,
            id: Number(rawId),
            name,
            kidCode,
            status: item.status || "",
          };
        })
        .filter(Boolean);
    },

    syncKidTableSelection() {
      this.$nextTick(() => {
        const table = this.$refs.kidDraftTable;
        if (!table || !table.toggleRowSelection) return;
        table.clearSelection();
        const selectedIds = new Set(this.form.listIdKids || []);
        this.filteredKidDraftList.forEach((row) => {
          if (selectedIds.has(row.id)) {
            table.toggleRowSelection(row, true);
          }
        });
      });
    },

    handleKidSelectionChange(val) {
      this.form.listIdKids = (Array.isArray(val) ? val : [])
        .map((item) => Number(item.id))
        .filter((id) => !Number.isNaN(id));
    },

    toggleFeeItem(id) {
      const idx = this.form.selectedFees.indexOf(id);
      if (idx === -1) {
        if (this.form.selectedFees.length >= 20) {
          NotifyMessage.leftCornerNotificationWarning("Bạn chỉ được chọn tối đa 20 khoản.");
          return;
        }
        this.form.selectedFees = [...this.form.selectedFees, id];
      } else {
        this.form.selectedFees = this.form.selectedFees.filter((x) => x !== id);
      }
      this.syncFeeSelectionState();
    },

    /* ─── Handlers: bộ lọc ─────────────────────────── */
    async handleTargetTypeChange() {
      this.resetDraftInvoicePreview();
      this.feeOptions  = [];
      this.form.selectedFees = [];
      this.checkAllFees      = false;
      this.isFeesIndeterminate = false;
      this.kidDraftList = [];
      this.form.listIdKids = [];

      if (this.isGroupMode && this.kidGroupList.length > 0) {
        this.form.idGroup = this.kidGroupList[0].id;
        await this.fetchFeeOptions();
        await this.fetchKidsInDraft();
      } else if (this.isClassMode && this.classList.length > 0) {
        this.form.idClass = this.classList[0].id;
        await this.fetchFeeOptions();
        await this.fetchKidsInDraft();
      } else if (this.isPackageMode) {
        if (this.packageList.length === 0) {
          await this.fetchPackages();
        } else {
          this.form.idPackage = this.packageList[0].id;
          await this.fetchFeeOptions();
          await this.fetchKidsInDraft();
        }
      }
    },

    async handlePackageChange() {
      this.resetDraftInvoicePreview();
      await this.fetchFeeOptions();
      await this.fetchKidsInDraft();
    },

    handleMonthChange(val) {
      if (!val) return;
      const parts      = val.split("-");
      this.form.month  = Number(parts[0]);
      this.form.year   = Number(parts[1]);

      const selectedMonth = moment(`${this.form.year}-${this.form.month}`, "YYYY-M");
      const prevMonth     = selectedMonth.clone().subtract(1, "month");

      this.form.dateRange = [
        selectedMonth.clone().startOf("month").toDate(),
        selectedMonth.clone().endOf("month").toDate(),
      ];
      this.form.preCalcDateRange = [
        selectedMonth.clone().startOf("month").toDate(),
        selectedMonth.clone().endOf("month").toDate(),
      ];
      this.form.postCalcDateRange = [
        prevMonth.clone().startOf("month").toDate(),
        prevMonth.clone().endOf("month").toDate(),
      ];

      this.resetDraftInvoicePreview();
      this.fetchFeeOptions();
      this.fetchKidsInDraft();
    },

    handleTurnChange() {
      this.resetDraftInvoicePreview();
      this.fetchFeeOptions();
    },

    handleGradeChange() {
      if (this.classList.length > 0) {
        this.form.idClass = this.classList[0].id;
      }
      this.resetDraftInvoicePreview();
      this.fetchFeeOptions();
      this.fetchKidsInDraft();
    },

    handleClassChange() {
      this.resetDraftInvoicePreview();
      this.fetchFeeOptions();
      this.fetchKidsInDraft();
    },

    handleGroupChange() {
      this.resetDraftInvoicePreview();
      this.fetchFeeOptions();
      this.fetchKidsInDraft();
    },

    /* ─── Fee checkboxes ────────────────────────────── */
    handleCheckAllFees(val) {
      if (val) {
        const allIds = this.feeOptions.map((x) => x.id);
        this.form.selectedFees = allIds;
      } else {
        this.form.selectedFees = [];
      }
      this.isFeesIndeterminate = false;
    },

    handleFeeSelectionChange(val) {
      if (val.length > 20) {
        NotifyMessage.leftCornerNotificationWarning("Bạn chỉ được chọn tối đa 20 khoản.");
        this.form.selectedFees = val.slice(0, 20);
        return;
      }
      const total              = this.feeOptions.length;
      this.checkAllFees        = val.length === total;
      this.isFeesIndeterminate = val.length > 0 && val.length < total;
    },

    /* ─── Balance radio ─────────────────────────────── */
    handleBalanceRadio(selected) {
      if (selected === "allTransaction") {
        this.form.forwardTransaction  = false;
        this.form.noForwardTransaction = false;
      } else if (selected === "forwardTransaction") {
        this.form.allTransaction      = false;
        this.form.noForwardTransaction = false;
      } else {
        this.form.allTransaction     = false;
        this.form.forwardTransaction = false;
      }
    },

    getRevenueColumnKey(detail) {
      return detail?.revenueCode || detail?.revenueName || "";
    },

    normalizeFeeColumns(invoiceList) {
      const map = new Map();
      (Array.isArray(invoiceList) ? invoiceList : []).forEach((invoice) => {
        (Array.isArray(invoice.invoiceDetails) ? invoice.invoiceDetails : []).forEach((detail) => {
          const key = this.getRevenueColumnKey(detail);
          if (!key || map.has(key) || map.size >= 20) return;
          const index = map.size + 1;
          map.set(key, {
            key,
            prop: `moneyKt${index}`,
            label: detail.revenueName || `Khoản thu ${index}`,
          });
        });
      });
      return Array.from(map.values());
    },

    normalizeInvoiceRow(invoice, columns) {
      const amountByKey = {};
      (Array.isArray(invoice.invoiceDetails) ? invoice.invoiceDetails : []).forEach((detail) => {
        const key = this.getRevenueColumnKey(detail);
        if (!key) return;
        amountByKey[key] = (amountByKey[key] || 0) + Number(detail.amount || 0);
      });

      const normalized = { ...invoice };
      // Đảm bảo mỗi row luôn có idx duy nhất (dùng làm row-key cho el-table)
      if (!normalized.idx) {
        normalized.idx = `draft-${normalized.idStudent || ''}-${normalized.month || ''}-${normalized.year || ''}-${normalized.turn || ''}-${Date.now()}`;
      }
      (Array.isArray(columns) ? columns : []).forEach((col) => {
        normalized[col.prop] = amountByKey[col.key] || 0;
      });
      return normalized;
    },

    normalizeFeeOptions(list) {
      return (Array.isArray(list) ? list : [])
        .map((item) => {
          const id = item.id || item.totalRevenueId || item.idRevenue || item.idRevenueManagement;
          const name =
            item.name ||
            item.totalRevenueName ||
            item.revenueName ||
            item.revenueManagementName ||
            "";

          if (!id || !name) return null;

          return {
            ...item,
            id,
            name,
            code: item.code || item.revenueCode || item.totalRevenueCode || "",
            active: typeof item.active === "boolean" ? item.active : item.registered !== false,
          };
        })
        .filter(Boolean);
    },

    syncFeeSelectionState() {
      const total = this.feeOptions.length;
      this.checkAllFees = total > 0 && this.form.selectedFees.length === total;
      this.isFeesIndeterminate =
        this.form.selectedFees.length > 0 && this.form.selectedFees.length < total;
    },

    /* ─── Fetch fee options ─────────────────────────── */
    async fetchFeeOptions() {
      const targetId = this.isClassMode
        ? this.form.idClass
        : (this.isGroupMode ? this.form.idGroup : this.form.idPackage);

      if (!targetId) {
        this.feeOptions = [];
        this.form.selectedFees = [];
        this.checkAllFees = false;
        this.isFeesIndeterminate = false;
        return;
      }

      try {
        const res = await RevenueScopeService.getRevenueScopeRegisterDetails({
          targetId,
          targetType: this.form.targetType,
          month: this.form.month,
          year: this.form.year,
          collectionTurn: this.form.collectionTurn,
        });
        const payload = res?.data?.data;
        const feeList = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.content)
            ? payload.content
            : [];

        this.feeOptions = this.normalizeFeeOptions(feeList);
        this.form.selectedFees = this.feeOptions
          .filter((item) => item.active)
          .slice(0, 20)
          .map((item) => item.id);
        this.syncFeeSelectionState();
      } catch (err) {
        console.error(err);
        this.feeOptions = [];
        this.form.selectedFees = [];
        this.checkAllFees = false;
        this.isFeesIndeterminate = false;
        // không cần notify lỗi – chỉ để fee list trống
      }
    },

    /* ─── Fetch kids in draft ───────────────────────── */
    async fetchKidsInDraft() {
      const targetId = this.isClassMode
        ? this.form.idClass
        : (this.isGroupMode ? this.form.idGroup : this.form.idPackage);

      if (!targetId || !this.form.kidStatus || !this.form.month || !this.form.year) {
        this.kidDraftList = [];
        this.form.listIdKids = [];
        return;
      }

      this.kidDraftLoading = true;
      try {
        const res = await tuitionDraftInvoiceService.getKidsInDraft({
          status: this.form.kidStatus,
          month: this.form.month,
          year: this.form.year,
          targetId,
          targetType: this.form.targetType,
        });

        const payload = res?.data?.data ?? res?.data;
        const kidList = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.content)
            ? payload.content
            : [];

        this.kidDraftList = this.normalizeKidDraftList(kidList);
        this.form.listIdKids = this.kidDraftList.map((item) => item.id);
        this.syncKidTableSelection();
      } catch (err) {
        console.error(err);
        this.kidDraftList = [];
        this.form.listIdKids = [];
      } finally {
        this.kidDraftLoading = false;
      }
    },

    /* ─── Fetch packages ────────────────────────────── */
    async fetchPackages() {
      try {
        const res = await PackageManagementService.getAll();
        this.packageList = res.data.data || [];
        if (this.packageList.length > 0) {
          if (!this.form.idPackage) {
            this.form.idPackage = this.packageList[0].id;
          }
          if (this.isPackageMode) {
            await this.fetchFeeOptions();
            await this.fetchKidsInDraft();
          }
        } else {
          this.form.idPackage = null;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async fetchGroups() {
      try {
        const res         = await GroupExcelService.getListKidsGroup();
        this.kidGroupList = res.data || [];
        if (this.kidGroupList.length > 0 && !this.form.idGroup) {
          this.form.idGroup = this.kidGroupList[0].id;
          await this.fetchFeeOptions();
          await this.fetchKidsInDraft();
        }
      } catch {
        NotifyMessage.leftCornerNotificationError("Lỗi tải danh sách nhóm!");
      }
    },

    async handleCreateOfficialInvoices() {
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) return;

        if (!this.selectedDraftInvoiceRows || this.selectedDraftInvoiceRows.length === 0) {
          NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn ít nhất một phiếu nháp để khởi tạo phiếu thu chính thức.");
          return;
        }

        try {
          await this.$confirm("Bạn có chắc chắn muốn khởi tạo phiếu thu chính thức cho các phiếu đã chọn không?", "Xác nhận", {
            confirmButtonText: "Đồng ý",
            cancelButtonText: "Hủy bỏ",
            type: "warning",
          });

          const payload = this.buildOfficialInvoicePayload(this.selectedDraftInvoiceRows);
          if (!payload.draftInvoices || payload.draftInvoices.length === 0) {
            NotifyMessage.leftCornerNotificationWarning("Không có phiếu nháp hợp lệ để phát hành chính thức.");
            return;
          }

          this.officialInvoiceLoading = true;
          const res = await tuitionDraftInvoiceService.createOfficialInvoices(payload);
          const responseData = res?.data?.data ?? res?.data ?? {};
          this.handleOfficialPublishResponse(responseData);
        } catch (err) {
          if (err === 'cancel') {
            NotifyMessage.leftCornerNotificationInfo("Đã hủy khởi tạo phiếu thu chính thức.");
          } else {
            console.error(err);
            NotifyMessage.leftCornerNotificationError(
              err?.response?.data?.message || "Khởi tạo phiếu thu chính thức thất bại!"
            );
          }
        } finally {
          this.officialInvoiceLoading = false;
        }
      });
    },

    /* ─── Tạo phiếu nháp ─────────────────────────────── */
    handleGenerate() {
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) return;
        if (!this.form.listIdKids || this.form.listIdKids.length === 0) {
          NotifyMessage.leftCornerNotificationWarning("Vui lòng chọn ít nhất một học sinh.");
          return;
        }

        this.isLoading = true;
        this.resetDraftInvoicePreview();

        const startDate = this.form.dateRange && this.form.dateRange[0]
          ? moment(this.form.dateRange[0]).format("YYYY-MM-DD")
          : null;
        const endDate = this.form.dateRange && this.form.dateRange[1]
          ? moment(this.form.dateRange[1]).format("YYYY-MM-DD")
          : null;

        const preCalcStartDate = this.form.preCalcDateRange && this.form.preCalcDateRange[0]
          ? moment(this.form.preCalcDateRange[0]).format("YYYY-MM-DD")
          : null;
        const preCalcEndDate = this.form.preCalcDateRange && this.form.preCalcDateRange[1]
          ? moment(this.form.preCalcDateRange[1]).format("YYYY-MM-DD")
          : null;

        const postCalcStartDate = this.form.postCalcDateRange && this.form.postCalcDateRange[0]
          ? moment(this.form.postCalcDateRange[0]).format("YYYY-MM-DD")
          : null;
        const postCalcEndDate = this.form.postCalcDateRange && this.form.postCalcDateRange[1]
          ? moment(this.form.postCalcDateRange[1]).format("YYYY-MM-DD")
          : null;

        const payload = {
          targetType:              this.form.targetType,
          month:                   this.form.month,
          year:                    this.form.year,
          idClass:                 this.isClassMode ? this.form.idClass : null,
          idGroup:                 this.isGroupMode ? this.form.idGroup : null,
          idPackage:               this.isPackageMode ? this.form.idPackage : null,
          startDate:               startDate,
          endDate:                 endDate,
          collectionTurn:          this.form.collectionTurn,
          description:         this.form.description || null,
          listIdRevenueManagement: this.form.selectedFees.length > 0 ? this.form.selectedFees : null,
          listIdKids:              this.form.listIdKids.length > 0 ? this.form.listIdKids : null,
          monthBeforeOrAfter:      this.form.monthBeforeOrAfter,
          allTransaction:          this.form.allTransaction,
          forwardTransaction:      this.form.forwardTransaction,
          noForwardTransaction:    this.form.noForwardTransaction,
          preCalcStartDate,
          preCalcEndDate,
          postCalcStartDate,
          postCalcEndDate,
        };

        try {
          const res = await tuitionDraftInvoiceService.generateDraftInvoices(payload);
          const rawInvoices = Array.isArray(res?.data?.data) ? res.data.data : [];
          this.feeColumns = this.normalizeFeeColumns(rawInvoices);
          this.invoiceList = rawInvoices.map((item) => this.normalizeInvoiceRow(item, this.feeColumns));
          this.hasResult = true;
          if (!this.invoiceList.length) {
            this.emptyText = this.$tableEmpty;
          } else {
            this.$nextTick(() => {
              if (this.$refs.invoiceDraftTable) {
                this.$refs.invoiceDraftTable.toggleAllSelection();
              }
            });
          }
        } catch (err) {
          console.error(err);
          NotifyMessage.leftCornerNotificationError(
            err?.response?.data?.message || "Tạo phiếu thu nháp thất bại!"
          );
        } finally {
          this.isLoading = false;
        }
      });
    },

    /* ─── Summary row ───────────────────────────────── */
    getSummaries({ columns, data }) {
      const sumProps = new Set([
        "beforeMoney",
        "sumMoney",
        "collectedMoney",
        "cashMoney",
        "transferMoney",
        "afterMoney",
        ...this.feeColumns.map((item) => item.prop),
      ]);
      const sums = [];
      columns.forEach((col, idx) => {
        if (col.property === "fullName") {
          sums[idx] = "Tổng cộng";
          return;
        }
        if (!sumProps.has(col.property)) {
          sums[idx] = "";
          return;
        }
        const vals = data.map((row) => Number(row[col.property]));
        if (!vals.every(isNaN)) {
          sums[idx] = vals
            .reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0)
            .toLocaleString("vi-VN", { style: "currency", currency: "VND" });
        } else {
          sums[idx] = "";
        }
      });
      return sums;
    },

    handleEditRevenueDetail(row, feeColumn) {
      if (!this.isFeeEditable(row, feeColumn.key)) {
        return;
      }

      if (!row.invoiceDetails || row.invoiceDetails.length === 0) {
        NotifyMessage.leftCornerNotificationWarning("Không có chi tiết khoản thu");
        return;
      }

      const matchingDetail = row.invoiceDetails.find(
        (detail) =>
          (detail.revenueCode || detail.revenueName || "") === feeColumn.key
      );

      if (!matchingDetail) {
        NotifyMessage.leftCornerNotificationWarning("Chi tiết khoản thu không tìm thấy");
        return;
      }

      // Tạo object với id từ idx (UUID)
      const detailForDialog = {
        ...matchingDetail,
        id: matchingDetail.idx || null,
      };

      this.$refs.editDetailDialog.open(detailForDialog);
    },

    handleEditCollectedMoney(row) {
      if (!row) return;
      const unifiedNote = this.resolveUnifiedNote(row);
      const rowKey = this.getInvoiceRowIdentityKey(row);
      const rowIndex = this.invoiceList.findIndex((item) => this.getInvoiceRowIdentityKey(item) === rowKey);
      this.$refs.editCollectedMoneyDialog.open({ ...row, note: unifiedNote }, rowIndex, rowKey);
    },

    handleRevenueDetailSaved() {
      this.handleGenerate();
    },

    handleCollectedMoneySaved(payload) {
      const idx = this.resolveInvoiceRowIndex(payload);
      if (idx === -1) {
        NotifyMessage.leftCornerNotificationWarning("Không tìm thấy dòng phiếu để cập nhật tiền đã thu.");
        return;
      }

      const currentRow = this.invoiceList[idx] || {};
      const unifiedNote = payload.note || "";
      const nextAdditionalInfo = this.normalizeAdditionalInfo({
        ...(currentRow.additionalInfo || {}),
        note: unifiedNote,
      });

      const updatedRow = {
        ...currentRow,
        beforeMoney: payload.beforeMoney,
        cashMoney: payload.cashMoney,
        transferMoney: payload.transferMoney,
        collectedMoney: payload.collectedMoney,
        afterMoney: payload.afterMoney,
        transactionEntry: payload.transactionEntry,
        note: unifiedNote,
        additionalInfo: nextAdditionalInfo,
      };

      this.$set(this.invoiceList, idx, updatedRow);

      // Đồng bộ vào selectedDraftInvoiceRows nếu dòng đó đang được chọn
      const selectedIndex = this.selectedDraftInvoiceRows.findIndex(
        (item) => (item.idx || item.id) === (updatedRow.idx || updatedRow.id)
      );
      if (selectedIndex !== -1) {
        this.$set(this.selectedDraftInvoiceRows, selectedIndex, updatedRow);
      }

      // Đồng bộ vào draft map của thông tin bổ sung để lần mở dialog sau luôn thấy cùng note.
      const idStudent = this.resolveStudentId(currentRow);
      if (idStudent) {
        this.setDraftAdditionalInfo({
          month: Number(currentRow?.month || this.form.month),
          year: Number(currentRow?.year || this.form.year),
          turn: Number(currentRow?.turn || this.form.collectionTurn),
          idStudent,
          targetType: this.form.targetType,
          data: nextAdditionalInfo,
        });
      }
      NotifyMessage.leftCornerNotificationSuccess("Cập nhật tiền đã thu thành công.");
    },

    resolveUnifiedNote(row, additionalInfo = null) {
      const fromAdditional = additionalInfo?.note ?? row?.additionalInfo?.note;
      const fromRow = row?.note;
      if (fromAdditional !== undefined && fromAdditional !== null && fromAdditional !== "") {
        return fromAdditional;
      }
      return fromRow || "";
    },

    getInvoiceRowIdentityKey(row) {
      if (!row) return "";
      // Ưu tiên idx (UUID) nếu có, vì id có thể null ở phiếu nháp
      if (row.idx) return row.idx;
      const idStudent = this.resolveStudentId(row) || "";
      const turn = Number(row.turn || 0);
      const month = Number(row.month || 0);
      const year = Number(row.year || 0);
      return `${idStudent}-${year}-${month}-${turn}`;
    },

    resolveInvoiceRowIndex(payload) {
      if (!payload) return -1;

      // 1) Ưu tiên idx (UUID) – phiếu nháp có id = null, chỉ có idx
      if (payload.idx) {
        const byIdx = this.invoiceList.findIndex((item) => item.idx === payload.idx);
        if (byIdx !== -1) return byIdx;
      }

      // 2) Fallback theo id phiếu (cho phiếu đã lưu DB)
      if (payload.id !== undefined && payload.id !== null && payload.id !== "") {
        const byId = this.invoiceList.findIndex((item) => String(item.id ?? "") === String(payload.id));
        if (byId !== -1) return byId;
      }

      // 3) Fallback theo rowKey (idStudent-year-month-turn)
      if (payload.rowKey) {
        const byKey = this.invoiceList.findIndex((item) => this.getInvoiceRowIdentityKey(item) === payload.rowKey);
        if (byKey !== -1) return byKey;
      }

      // 4) Fallback theo index đã chụp lúc mở dialog
      if (Number.isInteger(payload.rowIndex) && payload.rowIndex >= 0 && payload.rowIndex < this.invoiceList.length) {
        return payload.rowIndex;
      }

      return -1;
    },

    hasFeeAmount(value) {
      if (value === null || value === undefined) return false;
      const amount = Number(value);
      return !Number.isNaN(amount) && amount !== 0;
    },

    isFeeEditable(row, key) {
      if (!row || !Array.isArray(row.invoiceDetails)) return false;
      const detail = row.invoiceDetails.find(d => this.getRevenueColumnKey(d) === key);
      
      if (!detail || !detail.idx) return false;
      
      // Khóa khoản thu nếu số lượng = 0 và số tiền = 0 (tức là khoản này học sinh không học)
      if ((Number(detail.amount) || 0) === 0 && (Number(detail.quantity) || 0) === 0) {
        return false;
      }
      
      return true;
    },

    normalizeAdditionalInfo(data) {
      const defaults = {
        arriveT2t6: 0,
        arriveT7: 0,
        arriveCn: 0,
        absentCpT2t6: 0,
        absentKpT2t6: 0,
        absentCpT7: 0,
        absentKpT7: 0,
        leaveLater: 0,
        quantityDate: 0,
        note: "",
        arriveT2t6Total: 0,
        arriveT7Total: 0,
        arriveCnTotal: 0,
        absentCpT2t6Total: 0,
        absentKpT2t6Total: 0,
        absentCpT7Total: 0,
        absentKpT7Total: 0,
        leaveLaterTotal: 0,
        quantityDateTotal: 0,
        description: "",
        arriveT2t6TotalMonthBefore: 0,
        arriveT7TotalMonthBefore: 0,
        arriveCnTotalMonthBefore: 0,
        absentCpT2t6TotalMonthBefore: 0,
        absentKpT2t6TotalMonthBefore: 0,
        absentCpT7TotalMonthBefore: 0,
        absentKpT7TotalMonthBefore: 0,
        leaveLaterTotalMonthBefore: 0,
        quantityDateTotalMonthBefore: 0,
      };
      return {
        ...defaults,
        ...(data || {}),
      };
    },

    resolveStudentId(row) {
      const raw =
        row?.idStudent ||
        row?.idKid ||
        row?.kidsId ||
        row?.kidId ||
        row?.id;
      const id = Number(raw);
      return Number.isNaN(id) ? null : id;
    },

    getAdditionalInfoKey({ month, year, turn, idStudent, targetType }) {
      return `${targetType || "CLASS"}-${year}-${month}-${turn}-${idStudent}`;
    },

    getDraftAdditionalInfo({ month, year, turn, idStudent, targetType }) {
      const key = this.getAdditionalInfoKey({ month, year, turn, idStudent, targetType });
      return this.additionalInfoDraftMap[key] || null;
    },

    setDraftAdditionalInfo({ month, year, turn, idStudent, targetType, data }) {
      const key = this.getAdditionalInfoKey({ month, year, turn, idStudent, targetType });
      this.$set(this.additionalInfoDraftMap, key, this.normalizeAdditionalInfo(data));
    },

    async handleOpenAdditionalInfo(row) {
      const idStudent = this.resolveStudentId(row);
      const month = Number(row?.month || this.form.month);
      const year = Number(row?.year || this.form.year);
      const turn = Number(row?.turn || this.form.collectionTurn);
      const targetType = this.form.targetType;

      if (!idStudent) {
        NotifyMessage.leftCornerNotificationWarning("Không xác định được học sinh để lấy thông tin bổ sung.");
        return;
      }

      this.additionalInfoContext = {
        month,
        year,
        turn,
        idStudent,
        invoiceId: row?.id || null,
        invoiceIdx: row?.idx || null,
        targetType,
        studentName: row?.fullName || row?.name || "",
      };

      this.additionalInfoDialogVisible = true;
      this.additionalInfoLoading = true;

      const getRowVal = (key) => {
        if (row?.[key] !== undefined && row?.[key] !== null) return row[key];
        if (row?.additionalInfo?.[key] !== undefined && row?.additionalInfo?.[key] !== null) return row.additionalInfo[key];
        return null;
      };

      try {
        const res = await tuitionDraftInvoiceService.getAdditionalInfoForMonthAndTurn({
          month,
          idStudent,
          targetType,
          turn,
          year,
        });
        const payload = res?.data?.data ?? res?.data;
        const normalizedPayload = this.normalizeAdditionalInfo(payload);
        this.additionalInfoData = {
          ...normalizedPayload,
          arriveT2t6: getRowVal("arriveT2t6") ?? normalizedPayload.arriveT2t6,
          arriveT7: getRowVal("arriveT7") ?? normalizedPayload.arriveT7,
          arriveCn: getRowVal("arriveCn") ?? normalizedPayload.arriveCn,
          absentCpT2t6: getRowVal("absentCpT2t6") ?? normalizedPayload.absentCpT2t6,
          absentKpT2t6: getRowVal("absentKpT2t6") ?? normalizedPayload.absentKpT2t6,
          absentCpT7: getRowVal("absentCpT7") ?? normalizedPayload.absentCpT7,
          absentKpT7: getRowVal("absentKpT7") ?? normalizedPayload.absentKpT7,
          leaveLater: getRowVal("leaveLater") ?? normalizedPayload.leaveLater,
          quantityDate: getRowVal("quantityDate") ?? normalizedPayload.quantityDate,
          note: this.resolveUnifiedNote(row, normalizedPayload),
        };
        this.setDraftAdditionalInfo({
          month,
          year,
          turn,
          idStudent,
          targetType,
          data: this.additionalInfoData,
        });
      } catch (err) {
        console.error(err);
        // BE chưa có endpoint hoặc lỗi mạng: fallback dữ liệu local để vẫn chỉnh sửa được.
        this.additionalInfoData = {
          ...this.normalizeAdditionalInfo(null),
          arriveT2t6: getRowVal("arriveT2t6") ?? 0,
          arriveT7: getRowVal("arriveT7") ?? 0,
          arriveCn: getRowVal("arriveCn") ?? 0,
          absentCpT2t6: getRowVal("absentCpT2t6") ?? 0,
          absentKpT2t6: getRowVal("absentKpT2t6") ?? 0,
          absentCpT7: getRowVal("absentCpT7") ?? 0,
          absentKpT7: getRowVal("absentKpT7") ?? 0,
          leaveLater: getRowVal("leaveLater") ?? 0,
          quantityDate: getRowVal("quantityDate") ?? 0,
          note: this.resolveUnifiedNote(row, null),
        };
        this.setDraftAdditionalInfo({
          month,
          year,
          turn,
          idStudent,
          targetType,
          data: this.additionalInfoData,
        });
        NotifyMessage.leftCornerNotificationWarning(
          err?.response?.data?.message || "Chưa tải được dữ liệu BE, đang dùng dữ liệu tạm để chỉnh sửa."
        );
      } finally {
        this.additionalInfoLoading = false;
      }
    },

    handleAdditionalInfoSaved(payload) {
      const { month, year, turn, idStudent, invoiceId, invoiceIdx, targetType } = this.additionalInfoContext;
      if (!idStudent) return;

      const normalized = this.normalizeAdditionalInfo(payload);
      this.additionalInfoData = normalized;
      this.setDraftAdditionalInfo({
        month,
        year,
        turn,
        idStudent,
        targetType,
        data: normalized,
      });

      // Cập nhật ngay dòng tương ứng trong danh sách phiếu thu nháp
      // Ưu tiên match theo idx (UUID) vì id có thể null ở phiếu nháp
      let rowIndex = -1;
      if (invoiceIdx) {
        rowIndex = this.invoiceList.findIndex((item) => item.idx === invoiceIdx);
      }
      if (rowIndex === -1 && invoiceId !== null && invoiceId !== undefined) {
        rowIndex = this.invoiceList.findIndex((item) => item.id === invoiceId);
      }
      if (rowIndex === -1) {
        rowIndex = this.invoiceList.findIndex((item) => {
          const currentIdStudent = this.resolveStudentId(item);
          return (
            currentIdStudent === idStudent &&
            Number(item?.month) === Number(month) &&
            Number(item?.year) === Number(year) &&
            Number(item?.turn) === Number(turn)
          );
        });
      }

      if (rowIndex !== -1) {
        const currentRow = this.invoiceList[rowIndex] || {};
        const unifiedNote = normalized.note || "";
        const updatedRow = {
          ...currentRow,
          arriveT2t6: normalized.arriveT2t6,
          arriveT7: normalized.arriveT7,
          arriveCn: normalized.arriveCn,
          absentCpT2t6: normalized.absentCpT2t6,
          absentKpT2t6: normalized.absentKpT2t6,
          absentCpT7: normalized.absentCpT7,
          absentKpT7: normalized.absentKpT7,
          leaveLater: normalized.leaveLater,
          quantityDate: normalized.quantityDate,
          additionalInfo: {
            ...normalized,
            note: unifiedNote,
          },
          note: unifiedNote,
          description: normalized.description,
        };

        this.$set(this.invoiceList, rowIndex, updatedRow);

        // Đồng bộ vào selectedDraftInvoiceRows nếu dòng đó đang được chọn
        const selectedIndex = this.selectedDraftInvoiceRows.findIndex(
          (item) => (item.idx || item.id) === (updatedRow.idx || updatedRow.id)
        );
        if (selectedIndex !== -1) {
          this.$set(this.selectedDraftInvoiceRows, selectedIndex, updatedRow);
        }
      }

      NotifyMessage.leftCornerNotificationSuccess("Đã lưu thông tin bổ sung.");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

/* =====================================================
   TuitionDraftInvoice – Prefix: tdi-
   ===================================================== */

.tdi-page {
  padding: 4px 0 24px;
  .row-data { margin-bottom: 20px; }
}

/* ─── Toolbar card ─────────────────────────────────── */
.tdi-toolbar-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px;
}

/* ─── Table card ───────────────────────────────────── */
.tdi-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 20px 24px 16px;
}

/* ─── Card head ────────────────────────────────────── */
.tdi-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}

.tdi-card-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.tdi-card-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.6;
  color: #64748b;

  p {
    margin: 0 0 8px;
  }

  .tdi-info-list {
    margin: 0;
    padding-left: 20px;
    li {
      margin-bottom: 4px;
    }
  }
}

/* ─── Form grid ────────────────────────────────────── */
.tdi-form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  margin-bottom: 16px;
}

.tdi-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

/deep/ .tdi-form-item .el-form-item__label {
  padding-bottom: 4px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 600;
}

/* ─── Option row ──────────────────────────────────── */
.tdi-option-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 16px;
}

.tdi-option-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 200px;
}

.tdi-option-label {
  font-size: 12.5px;
  font-weight: 700;
  color: #374151;
}

.tdi-option-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.tdi-fee-count {
  font-size: 12.5px;
  color: #2563eb;
  font-weight: 600;
}

.tdi-detail-link {
  font-size: 12.5px;
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
  &:hover { color: #1d4ed8; }
}

.tdi-attendance-hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  line-height: 1.4;
  color: #1e40af;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 4px 10px;
  margin-top: 2px;
  width: fit-content;
  max-width: 100%;

  i {
    color: #2563eb;
    font-size: 13px;
    flex-shrink: 0;
  }

  strong {
    color: #1d4ed8;
    font-weight: 700;
  }
}

/* ─── Kid draft list ──────────────────────────────── */
.tdi-kid-list-block {
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  background: #ffffff;
}

.tdi-kid-list-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.tdi-kid-list-title {
  margin: 0 0 4px;
  font-size: 13.5px;
  font-weight: 700;
  color: #1e293b;
}

.tdi-kid-list-subtitle {
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
}

.tdi-kid-list-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  color: #475569;
  font-size: 12.5px;
  white-space: nowrap;
}

.tdi-kid-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.tdi-kid-table {
  border-radius: 12px;
  overflow: hidden;
}

/* ─── Action row ──────────────────────────────────── */
.tdi-action-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ─── Table wrapper ────────────────────────────────── */
.tdi-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

.tdi-table-action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #cbd5e1;
}

.tdi-table-action-summary {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12.5px;
  color: #475569;
}

.tdi-table-action-summary strong {
  color: #1e293b;
}

.tdi-table-action-hint {
  color: #b45309;
}

/* ─── Expand wrapper ───────────────────────────────── */
.tdi-expand-wrapper {
  padding: 12px 16px 16px;
  background: #f8fafc;
}

.tdi-expand-title {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: #1e40af;
}

/* ─── Inner table ──────────────────────────────────── */
.tdi-inner-table {
  border-radius: 10px;
  overflow: hidden;
}

/* ─── Money & Text helpers ─────────────────────────── */
.tdi-student-name-cell {
  font-weight: 700;
  color: #0f172a;
  font-size: 13.5px;
}
.tdi-money,
.tdi-money--bold,
.tdi-money--negative,
.tdi-money--positive {
  font-variant-numeric: tabular-nums;
  font-size: 13px;
}
.tdi-money {
  color: #475569;
}
.tdi-money--bold     { font-weight: 700; color: #1e293b; }
.tdi-money--negative { color: #dc2626; font-weight: 600; }
.tdi-money--positive { color: #16a34a; font-weight: 600; }
.tdi-text-muted      { color: #94a3b8; font-size: 13px; }

/* ─── Fee checkbox ─────────────────────────────────── */
.tdi-fee-checkbox {
  display: block;
  margin-top: 8px;
  margin-left: 0 !important;
}

/* ─── No fee notice ────────────────────────────────── */
.tdi-no-fee {
  text-align: center;
  color: #64748b;
  font-size: 13px;
  padding: 16px 0;
}

/* ─── Row Hover Accent Line ────────────────────────── */
/deep/ .sk-table tbody tr.hover-row {
  & > td {
    background-color: #f0f7ff !important;
  }
  
  & > td:first-child {
    position: relative;
    
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 4px;
      background-color: #3b82f6;
      z-index: 10;
    }
  }
}

/* ─── Premium Tag Styles ───────────────────────────── */
/deep/ .el-tag {
  border-radius: 6px !important;
  font-weight: 600;
  padding: 0 10px;
  height: 24px;
  line-height: 22px;
  border-width: 1px;
}

/deep/ .el-tag--success {
  background-color: #f0fdf4 !important;
  border-color: #bbf7d0 !important;
  color: #15803d !important;
}

/deep/ .el-tag--danger {
  background-color: #fef2f2 !important;
  border-color: #fecaca !important;
  color: #b91c1c !important;
}

/deep/ .el-tag--warning {
  background-color: #fffbeb !important;
  border-color: #fef3c7 !important;
  color: #b45309 !important;
}

/deep/ .el-tag--info {
  background-color: #f8fafc !important;
  border-color: #cbd5e1 !important;
  color: #475569 !important;
}

/* ─── Table header: xanh primary ──────────────────── */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead tr    { height: 52px; }
/deep/ .sk-table tbody td    { background: #ffffff; }

/* Inner table header: xanh nhạt */
/deep/ .tdi-inner-table thead th,
/deep/ .tdi-inner-table thead td {
  background: #dbeafe !important;
  color: #1e40af !important;
  font-weight: 600;
}
/deep/ .tdi-inner-table thead th > .cell,
/deep/ .tdi-inner-table thead td > .cell {
  color: #1e40af !important;
}
/deep/ .tdi-inner-table tbody td { background: #f8fafc; }

/* Summary row */
/deep/ .el-table__footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #f0f9ff;
  color: #0957f4;
}
/deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
  font-weight: bold;
  background-color: #f0f9ff;
  color: #0957f4;
}

/* ─── Input / Button ──────────────────────────────── */
/deep/ .tdi-page .el-input__inner,
/deep/ .tdi-page .el-select .el-input__inner { border-radius: 10px; }
/deep/ .tdi-page .el-button { border-radius: 10px; }
/deep/ .tdi-page .el-radio-button__inner { border-radius: 0; }
/deep/ .tdi-page .el-radio-group .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 10px 0 0 10px;
}
/deep/ .tdi-page .el-radio-group .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 10px 10px 0;
}

/* ─── Fee dialog ──────────────────────────────────── */
.tdi-fd-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.tdi-fd-count {
  font-size: 13px;
  color: #475569;
  white-space: nowrap;
  flex-shrink: 0;
}

.tdi-fd-count-val {
  color: #2563eb;
  font-weight: 700;
}

.tdi-fd-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 6px 0;
  background: #f8fafc;
}

.tdi-fd-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid #f1f5f9;
  user-select: none;

  &:last-child { border-bottom: none; }
  &:hover { background: #eff6ff; }
  &.tdi-fd-item--checked { background: #dbeafe; }
}

.tdi-fd-checkbox {
  flex-shrink: 0;
  /deep/ .el-checkbox__inner { border-radius: 4px; }
}

.tdi-fd-label {
  font-size: 13px;
  color: #1e293b;
  line-height: 1.4;
}

.tdi-fd-code {
  font-family: monospace;
  font-weight: 700;
  color: #2563eb;
  font-size: 12px;
  background: #eff6ff;
  padding: 1px 5px;
  border-radius: 4px;
}

.tdi-fd-sep {
  color: #94a3b8;
  margin: 0 1px;
}

.tdi-fd-empty {
  text-align: center;
  color: #64748b;
  font-size: 13px;
  padding: 28px 16px;
}

.tdi-fd-empty-icon {
  font-size: 32px;
  color: #cbd5e1;
  display: block;
  margin-bottom: 8px;
}

/* ─── Responsive ──────────────────────────────────── */
@media (max-width: 1200px) {
  .tdi-card-head { flex-direction: column; align-items: flex-start; }
  .tdi-kid-list-head { flex-direction: column; }
}

@media (max-width: 768px) {
  .tdi-form-grid    { flex-direction: column; }
  .tdi-option-row   { flex-direction: column; }
  .tdi-kid-toolbar  { flex-direction: column; align-items: stretch; }
  .tdi-kid-list-meta { white-space: normal; }
  .tdi-action-row   { justify-content: center; }
  .tdi-table-action-row { flex-direction: column; align-items: stretch; }
}

/* ─── Finance column styling ──────────────────────── */
/deep/ .sk-table thead th.tdi-finance-header,
/deep/ .sk-table thead td.tdi-finance-header {
  background: #0f766e !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

/deep/ .sk-table thead th.tdi-finance-header > .cell,
/deep/ .sk-table thead td.tdi-finance-header > .cell {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/deep/ .sk-table tbody td.tdi-finance-column {
  background-color: #f0fdfa !important;
}

/* ─── Fee column styling ─────────────────────────── */
/deep/ .sk-table thead th.tdi-fee-header,
/deep/ .sk-table thead td.tdi-fee-header {
  background: #6d28d9 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

/deep/ .sk-table thead th.tdi-fee-header > .cell,
/deep/ .sk-table thead td.tdi-fee-header > .cell {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/deep/ .sk-table tbody td.tdi-fee-column {
  background-color: #f5f3ff !important;
}

/deep/ .sk-table tbody td.tdi-fee-column .cell {
  color: #5b21b6;
  font-weight: 600;
}

/deep/ .tdi-fee-amount {
  width: 100%;
  padding: 12px 8px;
  color: #6d28d9;
  font-weight: 600;
  text-align: right;
  display: block;
  border: none;
  background: transparent;
}

/deep/ .tdi-fee-amount:hover {
  color: #4c1d95;
  text-decoration: underline;
}

/deep/ .tdi-fee-amount.is-disabled,
/deep/ .tdi-fee-amount.is-disabled:hover {
  color: #cbd5e1;
  text-decoration: none;
  cursor: not-allowed;
}

.tdi-money--fee {
  color: #6d28d9;
  font-weight: 700;
}

.tdi-additional-info-btn {
  font-size: 16px;
  color: #2563eb;
}
</style>